export default __webpack_public_path__ + "static/media/wellstar-top.1940c613.svg";